<section class="flex h-full w-full flex-col overflow-hidden bg-white text-slate-900" role="dialog">
  <header class="flex shrink-0 items-center gap-3 border-b !border-slate-100 px-4 py-3">
    <div class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-orange-50 text-orange-600">
      <app-icon>warehouse</app-icon>
    </div>
    <h2 class="m-0 min-w-0 flex-1 truncate text-base font-bold leading-6">
      {{ warehouse ? warehouse.name : ('stock.warehouse_form.title_new' | translate) }}
    </h2>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100"
      [attr.aria-label]="'close' | translate"
      (click)="close.emit()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <form class="crm-scroll flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 py-4" (ngSubmit)="submit()">
    <app-input
      [formControl]="form.controls.name"
      [label]="'stock.warehouse_form.name' | translate"
      [required]="true"
      [maxlength]="255"
    />
    <app-textarea [formControl]="form.controls.description" [label]="'description' | translate" [maxLength]="10000" />

    <div class="flex flex-col gap-2">
      <span class="text-sm font-medium text-slate-700">{{ 'address' | translate }}</span>
      <app-board-v3-address-editor [formControl]="form.controls.addresses" [single]="true" />
    </div>

    <div class="flex items-start gap-3 rounded-lg border !border-slate-200 bg-slate-50 p-3">
      <app-toggle [formControl]="form.controls.allow_negative" labelPosition="after">
        <span class="text-sm font-medium text-slate-800">{{ 'stock.allow_negative' | translate }}</span>
      </app-toggle>
    </div>
    <p class="-mt-2 m-0 text-xs leading-5 text-slate-500">
      {{ 'stock.warehouse_form.allow_negative_hint' | translate }}
    </p>
  </form>

  <footer class="flex shrink-0 gap-2 border-t !border-slate-100 px-4 py-3">
    <app-button
      btnType="stroked"
      class="flex-1"
      [customClass]="'w-full !h-10 !rounded-lg'"
      (onChangeClick)="close.emit()"
    >
      {{ 'cancel' | translate }}
    </app-button>
    <app-button
      class="flex-1"
      [customClass]="'w-full !h-10 !rounded-lg'"
      [disabled]="saving"
      (onChangeClick)="submit()"
    >
      {{ (saving ? 'saving' : warehouse ? 'save' : 'create') | translate }}
    </app-button>
  </footer>
</section>
